<template>
  <b-modal
    ref="modal"
    body-class="!p-[24px] text-black w-full !rounded-[12px]"
    content-class="!rounded-[12px]"
    size="md"
    centered
    hide-footer
    hide-header
    @hide="reset"
  >
    <img
      :src="iconSrc"
      alt="warning packet removal"
      class="w-[98px] mx-auto mb-[24px]"
    >
    <h3 class="text-[18px] font-medium text-center mb-[4px] text-[#0A0A0A]">
      {{ title }}
    </h3>
    <p class="text-[14px] text-center mb-[24px] text-[#737373]">
      {{ description }}
    </p>
    <div
      class="grid gap-[8px]"
      :class="{ 'sm:grid-cols-2': !hideCancel}"
    >
      <Button
        v-if="!hideCancel"
        class="w-full px-[16px] py-[8px] h-auto"
        outline
        :disabled="isSubmitting"
        @click="handleCloseModal"
      >
        Batal
      </Button>
      <Button
        class="w-full px-[16px] py-[8px] h-auto flex justify-center items-center gap-[8px]"
        :variant="saveBtn.variant"
        :outline="saveBtn.outline"
        :disabled="isSubmitting"
        @click="handleSave"
      >
        <b-spinner
          v-if="isSubmitting"
          class="w-[16px] h-[16px]"
          small
        />
        {{ saveBtn.label }}
      </Button>
    </div>
  </b-modal>
</template>

<script>
/**
 * @component ModalInputResi
 * @description Displays a modal to input airway bills (resi) for a given packet.
 *
 * @example
 * <ModalInputResi ref="modalInputResi" />
 * this.$refs.modalInputResi.show({
 *   data: packet,
 *   onSaveFn: ({ awbs, data }) => { ... }
 * })
 */
import { Button } from '@/@core/components/ui'

export default {
  components: {
    Button,
  },
  data() {
    return {
      data: {},
      title: 'Konfirmasi Hapus',
      description: 'Apakah kamu yakin untuk menghapus jenis paket ini?',
      hideCancel: false,
      isSubmitting: false,
      saveBtn: {
        label: 'Hapus',
        variant: 'primary',
        outline: false,
      },
      iconSrc: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
    }
  },
  computed: {
    packetType() {
      return (this.data.index || 0) + 1
    },
  },
  created() {
    this.onSaveFn = null
    this.onResetFn = null
  },
  methods: {
    show({
      data,
      onSaveFn,
      onResetFn,
      title,
      description,
      hideCancel,
      saveBtn,
      iconSrc,
    }) {
      this.data = data || {}
      this.onSaveFn = onSaveFn
      this.onResetFn = onResetFn
      this.title = title
      this.description = description
      this.hideCancel = hideCancel
      this.isSubmitting = false
      this.iconSrc = iconSrc || 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png'
      this.saveBtn = saveBtn || {
        label: 'Hapus',
        variant: 'primary',
        outline: false,
      }
      this.$refs.modal.show()
    },
    reset() {
      if (this.onResetFn) {
        this.onResetFn()
      }
      this.data = {}
      this.onSaveFn = null
      this.onResetFn = null
      this.title = 'Konfirmasi Hapus'
      this.description = 'Apakah kamu yakin untuk menghapus jenis paket ini?'
      this.hideCancel = false
      this.isSubmitting = false
      this.iconSrc = 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png'
      this.saveBtn = {
        label: 'Hapus',
        variant: 'primary',
        outline: false,
      }
    },
    hide() {
      this.reset()
      this.$refs.modal.hide()
    },
    handleCloseModal() {
      if (this.isSubmitting) return
      this.hide()
    },
    async handleSave() {
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        const { data } = this
        if (this.onSaveFn) {
          await this.onSaveFn({
            data,
          })
        }
        this.hide()
      } catch (error) {
        console.error('Error while saving:', error)
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>
